import { Pipe, PipeTransform } from '@angular/core';
import { ITimeSeriesInfo } from '../interfaces';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'filterSeriesInfo',
})
export class FilterSeriesInfoPipe implements PipeTransform {
  constructor(private _decimalPipe: DecimalPipe) {}

  transform(
    seriesInfos: ITimeSeriesInfo[],
    frontendIndex: number,
    decimalPlaces?: number,
    customUnit?: string
  ): any {
    if (!seriesInfos || seriesInfos == undefined || seriesInfos.length == 0)
      return null;

    var decimalPlacesValue;
    if (decimalPlaces != undefined) {
      decimalPlacesValue = this._decimalPipe.transform(
        seriesInfos.filter(
          (singleSeries: ITimeSeriesInfo) =>
            singleSeries.indexFrontend == frontendIndex
        )[0].lastValue,
        `0.${decimalPlaces}-${decimalPlaces}`,
        'en'
      );
    } else {
      decimalPlacesValue = this._decimalPipe.transform(
        seriesInfos.filter(
          (singleSeries: ITimeSeriesInfo) =>
            singleSeries.indexFrontend == frontendIndex
        )[0].lastValue,
        '1.1-1',
        'en'
      );
    }

    var unit = seriesInfos.filter(
      (singleSeries: ITimeSeriesInfo) =>
        singleSeries.indexFrontend == frontendIndex
    )[0].unit;

    if (unit != 'º') unit = ' ' + unit;

    if (decimalPlacesValue == null) return ` -`;
    else if (customUnit) return `${decimalPlacesValue} ${customUnit}`;
    else return `${decimalPlacesValue}${unit}`;
  }
}
